<template>
  <div class="dropdown-wrapper" ref="dropdownWrapper" @click="openDropdown">
    <slot />

    <div class="dropdown-content shadow-lg border" ref="dropdown">
      <ul>
        <li v-for="item in props.list">

          <a :href="item.link" v-if="!item.sub">
            {{ item.title }}
          </a>

          <a v-else>
            {{ item.title }}
          </a>

          <ul v-if="item.sub">
            <li v-for="itemSub in item.sub">
              <a :href="itemSub.link">
                {{ itemSub.title }}
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
  import { ref } from 'vue'
  import { onClickOutside } from '@vueuse/core'

  const dropdownWrapper = ref(null)
  const dropdown = ref(null)

  const props = defineProps({
    list: Array,
  })

  function openDropdown() {
    dropdown.value.style.display = 'block'

    setTimeout(() => {
      dropdown.value.classList.add('show')
    })
  }

  function closeDropdown() {
    dropdown.value.classList.remove('show')

    setTimeout(() => {
      dropdown.value.style.display = ''
    }, 200)
  }

  onClickOutside(dropdownWrapper, () => {
    closeDropdown()
  })
</script>

<style scoped lang="scss">
  @import '@sass/global/functions';

  .no-click {
    pointer-events: none;
  }

  .dropdown-wrapper {
    position: relative;
    width: fit-content;
    max-width: 100%;
    display: inline-block;
    margin-right: 8px;
  }

  .dropdown-content {
    min-width: 100%;
    max-width: 90vw;
    width: max-content;
    position: absolute;
    background-color: #fff;
    top: calc(100% + 4px);
    right: 0%;
    opacity: 0;
    transform: scale(0.8);
    transform-origin: top right;
    transition: 0.2s cubic-bezier(0.41, -0.16, 0.33, 1.39);
    border-radius: 10px;
    display: none;
    overflow: hidden;
    cursor: auto;
    z-index: 100;

    ul {
      padding: 0;
      margin: 0;

      li {
        a {
          padding: 12px 32px;
          color: #000;
          display: block;
          text-decoration: none;

          &:hover {
            background-color: rgb(0 0 0 / 15%);
          }
        }

        ul {
          border-left: 4px solid color(--primary);
          li {
            a {
              padding-left: 32px;
            }
          }
        }
      }
    }

    &.show {
      transform: scale(1);
      opacity: 1;
    }
  }
</style>
